import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Flexbox from "core/Flexbox";
import Div from "core/Div";
import Heading from "core/Heading";
import BodyText from "core/BodyText";
import colors from "core/colors";
import { OrderItem, Thumbnail } from "./styles";

const OrderSummaryBody = ({
    className,
    thumbnail,
    itemTitle,
    itemPriceOrderSummaryItem,
    orderSummaryTextLine1,
    orderSummaryTextLine2
}) => {
    return (
        <OrderItem
            className={className}
            alignItems="center"
            justifyContent="space-between"
        >
            <Flexbox alignItems="center" justifyContent="space-between">
                {!!thumbnail && <Thumbnail src={thumbnail} alt={itemTitle} />}

                <Div>
                    <BodyText type="div" size="sm" copyColor={colors.midnight}>
                        {orderSummaryTextLine1}
                    </BodyText>

                    <BodyText type="div" size="sm" copyColor={colors.storm}>
                        {orderSummaryTextLine2}
                    </BodyText>
                </Div>
            </Flexbox>

            {!!thumbnail && (
                <Heading
                    type="p"
                    size="xs"
                    headingColor={colors.midnight}
                    alignment="right"
                >
                    {itemPriceOrderSummaryItem}
                </Heading>
            )}
        </OrderItem>
    );
};

const OrderSummaryItem = styled(OrderSummaryBody)``;

OrderSummaryItem.propTypes = {
    className: PropTypes.string,
    thumbnail: PropTypes.string.isRequired,
    itemTitle: PropTypes.string.isRequired,
    itemPriceOrderSummaryItem: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    orderSummaryTextLine1: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    orderSummaryTextLine2: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired
};

export default OrderSummaryItem;
